import { doc, updateDoc } from 'firebase/firestore'
import { newFirestore } from '../../../utils/firebase/firebase'

export const togglePublishedClass = async (id, currentState) => {
  const classRef = doc(newFirestore, 'bookings', id)
  await updateDoc(classRef, {
    isPublished: !currentState,
  })
}
